const sizes = {
  a: 0,
  b: 421,
  c: 801,
  d: 1201,
};

export { sizes };
